(() => {
  if (typeof window.customElements.get('band-case-select') !== 'undefined') {
    return;
  }

  window.customElements.define(
    'band-case-select',
    class BandUpsells extends HTMLElement {
      constructor() {
        super();

        this.selectButtons = this.querySelectorAll('[data-select-face-button]');
        this.swiperContainer = this.querySelector('[data-band-case-select-swiper-container]');
        this.overlayImageWrapper = document.querySelector('[data-band-upsells-watch-wrapper]');
        this.skuSpan = this.querySelector('[data-selected-product-sku]');
        this.selectedColorSpan = this.querySelector('[data-selected-color]');
        this.bandSection = document.querySelector('[data-bands-upsells-accordion]');
        this.navNextButton = this.querySelector('[data-case-select-nav-next]');
        this.navPrevButton = this.querySelector('[data-case-select-nav-prev]');
        this.changeModelButton = this.querySelector('[data-change-model-button]');
      }

      connectedCallback() {
        this.setupSwiper();
        this.initSelectButtons();
        this.initChangeButton();
      }

      setupSwiper() {
        if (!this.swiperContainer) {
          return;
        }

        const bandUpsellsSwiper = new Swiper(this.swiperContainer, {
          slidesPerView: 'auto',
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
          slidesOffsetBefore: 15,
          slidesOffsetAfter: 15,
          on: {
            progress: (swiper, progress) => {
              this.swiperContainer.classList.toggle('at-start', progress === 0);
              this.swiperContainer.classList.toggle('at-end', progress === 1);
            },
          },
          navigation: {
            nextEl: this.navNextButton,
            prevEl: this.navPrevButton,
          },
          breakpoints: {
            750: {
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 15,
            },
          },
        });

        return bandUpsellsSwiper;
      }

      initSelectButtons() {
        this.selectButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            this.updateOverlayImage(event.currentTarget);
            this.updateSku(event.currentTarget);
            this.updateSelectedColor(event.currentTarget);
            this.updateSelectedButton(event.currentTarget);
            this.scrollToBandSection();
          });
        });
      }

      initChangeButton() {
        const bandsSelectSection = document.querySelector('.bands-select-model');

        this.changeModelButton.addEventListener('click', (event) => {
          event.preventDefault();
          this.scrollToElement(bandsSelectSection);
        });
      }

      scrollToBandSection() {
        setTimeout(() => {
          this.scrollToElement(this.bandSection);
        }, 200);
      }

      scrollToElement(element) {
        if (element) {
          // Scroll to the band section smoothly
          const headerGroupSections = document.querySelectorAll('.shopify-section-group-header-group');
          const elementOffsetTop = element.offsetTop;
          const totalHeaderOffset = Array.from(headerGroupSections).reduce((total, el) => {
            return total + el.offsetHeight;
          }, 0);
          const scrollTop = elementOffsetTop - totalHeaderOffset + 75;
    
          window.scrollTo({
            top: scrollTop,
            behavior: 'smooth'
          });
        }
      }

      updateSelectedButton(button) {
        this.selectButtons.forEach((btn) => {
          const isSelected = btn === button;
          btn.classList.toggle('button--secondary', !isSelected);
          btn.toggleAttribute('aria-pressed', isSelected);
          btn.innerHTML = isSelected
            ? `<svg
                xmlns="http://www.w3.org/2000/svg"
                height="20px"
                viewBox="0 -960 960 960"
                width="20px"
                fill="currentColor"
              >
                <path d="M382-221.91 135.91-468l75.66-75.65L382-373.22l366.43-366.43L824.09-664 382-221.91Z"/>
              </svg>
              <span>Selected</span>`
            : `<span>Select Color</span>`;
        });
      }

      updateSelectedColor(button) {
        const color = button.getAttribute('data-color');
        if (!color) {
          return;
        }

        this.selectedColorSpan.textContent = color;
      }

      updateSku(button) {
        const sku = button.getAttribute('data-sku');
        if (!sku) {
          return;
        }

        this.skuSpan.textContent = sku;
      }

      updateOverlayImage(button) {
        const imgUrl = button.getAttribute('data-overlay-image-url');
        if (!imgUrl) {
          return;
        }

        this.overlayImageWrapper.innerHTML = '';
        this.overlayImageWrapper.appendChild(this.createImageElement(imgUrl));
      }

      createImageElement(imgUrl) {
        const img = document.createElement('img');
        img.src = imgUrl;
        img.alt = 'Selected Watch Face';
        img.classList.add('band-upsells__watch-image');
        return img;
      }
    }
  );
})();
